// extracted by mini-css-extract-plugin
module.exports = {"widgetLoader":"WidgetLoader_widgetLoader__lFYDt","circle":"WidgetLoader_circle__2f7mY","strip":"WidgetLoader_strip__3HZ7i","strip_small":"WidgetLoader_strip_small__2oGKR"};